import { render, staticRenderFns } from "./DistributeCustom.vue?vue&type=template&id=02ed09b2&scoped=true"
import script from "./DistributeCustom.vue?vue&type=script&lang=js"
export * from "./DistributeCustom.vue?vue&type=script&lang=js"
import style0 from "./DistributeCustom.vue?vue&type=style&index=0&id=02ed09b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ed09b2",
  null
  
)

export default component.exports